import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Eye, EyeOff, Copy, Check } from "lucide-react";
import { copySensitive, copyPlain } from "@/lib/vaultCrypto";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

/** Passordfelt med vis/skjul og kopier. Verdien rendres aldri i DOM når den er skjult (type=password). */
export const PasswordField = ({ value, onChange, readOnly = false, id, placeholder, testId = "password-field", clearSeconds = 30, className, autoComplete = "new-password", sensitive = true }) => {
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    if (!value) return;
    try {
      if (sensitive) await copySensitive(value, clearSeconds); else await copyPlain(value);
      setCopied(true);
      toast.success(sensitive ? `Kopiert – tømmes fra utklippstavlen om ${clearSeconds} s` : "Kopiert", { id: `copy-${testId}` });
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Kunne ikke kopiere. Tillat utklippstavle i nettleseren.");
    }
  };

  return (
    <div className={cn("flex items-center gap-1", className)}>
      <Input
        id={id}
        type={show ? "text" : "password"}
        value={value || ""}
        onChange={onChange}
        readOnly={readOnly}
        placeholder={placeholder}
        autoComplete={autoComplete}
        spellCheck={false}
        className={cn("font-mono tracking-wide", readOnly && "bg-secondary/60")}
        data-testid={`${testId}-input`}
      />
      <Button type="button" variant="ghost" size="icon" className="h-10 w-10 shrink-0" onClick={() => setShow((s) => !s)} aria-label={show ? "Skjul" : "Vis"} aria-pressed={show} data-testid={`${testId}-toggle`}>{show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}</Button>
      <Button type="button" variant="ghost" size="icon" className="h-10 w-10 shrink-0" onClick={copy} disabled={!value} aria-label="Kopier" data-testid={`${testId}-copy`}>{copied ? <Check className="h-4 w-4 text-success" /> : <Copy className="h-4 w-4" />}</Button>
    </div>
  );
};
